import { render, staticRenderFns } from "./message-display.vue?vue&type=template&id=174da74e"
import script from "./message-display.vue?vue&type=script&lang=js"
export * from "./message-display.vue?vue&type=script&lang=js"
import style0 from "./message-display.vue?vue&type=style&index=0&id=174da74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports